import * as React from 'react';
import styles from './BillCollectionMethod.module.scss'
import { useState } from "react";
import TextField from '@mui/material/TextField';
import Card from "../Card/Card";
import { Box, Button, Grid } from "@mui/material";
import Typography from '@mui/material/Typography';
import Mail from '../../assets/Mail.svg'
import email from '../../assets/email.svg'
import { useForm, Controller } from 'react-hook-form'
import SendRequest from "../../request/SendRequest";
import MenuItem from '@mui/material/MenuItem';
import Dialog from '@mui/material/Dialog';
import { CloseButton } from "react-bootstrap";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { useTranslation } from "react-i18next";

const BillCollectionMethod = ({
    billingDeliveryData,
    availableAreaSubdistrictsData,
    noEmailInProfile,
    editProfile,
    setEditProfile,
    editBillingDeliveryMethod,
    setEditBillingDeliveryMethod,
    setSnackBar,
}) => {
    const { t } = useTranslation();
    const [availableAreaSubdistrictsOptions, setAvailableAreaSubdistrictsOptions] = useState(availableAreaSubdistrictsData.subdistricts[billingDeliveryData.addressInfo.area ?? "不適用"]);

    const [loading, setLoading] = useState(false)
    const [comfirmDialogOpen, setComfirmDialogOpen] = useState(false)
    const handleClose = () => {
        setComfirmDialogOpen(false)
    }

    const [updateEmailDialogOpen, setUpdateEmailDialogOpen] = useState(false)
    const handleUpdateEmailDialogClose = () => {
        setUpdateEmailDialogOpen(false)
    }

    const checkBillingDeliveryMethodEditable = (changeBillingMethod = false) => {
        if (noEmailInProfile) {
            setUpdateEmailDialogOpen(true)
        } else {
            if (changeBillingMethod) {
                setValue("billingDeliveryMethod", "email")
            }
            setEditBillingDeliveryMethod(true)
        }
    }

    const {
        register,
        setError,
        getValues,
        setValue,
        reset,
        handleSubmit,
        watch,
        control,
        formState: { errors },
    } = useForm({
        defaultValues: billingDeliveryData
    })
    const billingAddressLine = watch([
        "addressInfo.area",
        "addressInfo.secDistrict",
        "addressInfo.street",
        "addressInfo.court",
        "addressInfo.building",
        "addressInfo.block",
        "addressInfo.level",
        "addressInfo.flat",
    ])
    .map((value, index) => {
        if (index === 5 && value) {
            return value + "座";
        }
        if (index === 6 && value) {
            return value + "樓";
        }
        if (index === 7 && value) {
            return value + "室";
        }
        return value;
    })
    .filter((value) => value && value !== '不適用');

    const onSubmit = (data, e) => {
        setLoading(true)
        let submitData = {
            ...data,
        };

        SendRequest.post({ url: process.env.REACT_APP_API_URL + 'subscriber/billingDeliveryMethod', data: submitData }).then(response => {
            if (response.status === 200) {
                setEditBillingDeliveryMethod(!editBillingDeliveryMethod)
                setSnackBar({
                    open: true,
                    message: response.data.data.message ?? t("submit_success"),
                    severity: "success",
                })
            }
        }).catch(err => {
            if (err.response?.status === 422) {
                Object.keys(err.response?.data?.errors).map((key) => {
                    setError(key, { message: err.response?.data?.errors[key] })
                })
                if (Object.keys(err.response?.data?.errors).length > 0) {
                    setTimeout(() => {
                        const firstErrorField = Object.keys(err.response?.data?.errors)[0];
                        console.log(firstErrorField)
                        const input = document.querySelector(
                            `form[name="bill-collection-form"] input[name="${firstErrorField.replace(/\./g, '\\.')}"]`
                        );
                        if (input) {
                            input.scrollIntoView({
                                behavior: 'smooth',
                                block: 'center',
                            });
                        }
                    }, 500)
                }
            }
            else if (err.response?.status === 400) {
                setSnackBar({
                    open: true,
                    message: err.response?.data?.message ?? t("submit_fail"),
                    severity: "error",
                })
            } else {
                setSnackBar({
                    open: true,
                    message: t("system_busy"),
                    severity: "error",
                })
            }
        }).finally(() => {
            setLoading(false)
            handleClose()
        })
    }
    return (
        <>
            <Backdrop
                sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1301 })}
                open={loading}
                invisible
            >
                <CircularProgress style={{'color': '#495057'}} />
            </Backdrop>
            <div className={`subscriber-profile-info ${styles["subscriber-profile-info"]}`}>
                <Typography variant="h2" gutterBottom width={'100%'} textAlign={"left"} color={"rgba(67, 71, 78, 1)"} fontSize={"14px"} fontWeight={500}>
                    收帳單方式
                </Typography>
                <Card fullWidth={true}>
                {
                    (billingDeliveryData.canShowBillingDeliveryDetails === true) &&
                    <form name="bill-collection-form" className={styles["subscriber-profile-info-form"]} onSubmit={handleSubmit(onSubmit)}>
                        <Box width={"100%"} maxWidth={"356px"} display={"flex"} flexDirection={"column"} margin={"0 auto"} gap={"12px"}>
                        <Box width={"100%"} display={"flex"} flexDirection={"row"}>
                            <Controller
                                name="billingDeliveryMethod"
                                control={control}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        inputProps={{ readOnly: (!editBillingDeliveryMethod || !billingDeliveryData.canUpdateBillingDeliveryMethod) }}
                                        fullWidth
                                        variant="filled"
                                        label="收帳單方式"
                                        error={!!errors.billingDeliveryMethod}
                                        helperText={errors.billingDeliveryMethod ? errors.billingDeliveryMethod.message : ""}
                                        hidden
                                    />
                                )}
                            />
                            <Box width={"38px"} height={"38px"} borderRadius={"12px"} bgcolor={"#fff6f3"} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                                {
                                    getValues("billingDeliveryMethod") === "mail" &&
                                    <img src={Mail} style={{ width: '24px', height: '24px' }} />
                                }
                                {
                                    getValues("billingDeliveryMethod") === "email" &&
                                    <img src={email} style={{ width: '24px', height: '24px' }} />
                                }
                            </Box>
                            {
                                getValues("billingDeliveryMethod") === "mail" &&
                                <Box width={"100%"} padding={"10px 12px"} fontSize={"14px"} fontWeight={500} color={"#666666"} textAlign={"left"}>實體單</Box>
                            }
                            {
                                getValues("billingDeliveryMethod") === "email" &&
                                <Box width={"100%"} padding={"10px 12px"} fontSize={"14px"} fontWeight={500} color={"#666666"} textAlign={"left"}>電子郵件帳單</Box>
                            }
                        </Box>
                        {
                            getValues("billingDeliveryMethod") === "email" &&
                            <>
                                <Grid item xs={12}>
                                    <Controller
                                        name="emailAddress"
                                        control={control}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                inputProps={{ readOnly: !editBillingDeliveryMethod }}
                                                fullWidth
                                                label="電郵地址"
                                                error={!!errors.emailAddress}
                                                helperText={errors.emailAddress ? errors.emailAddress.message : ""}
                                                variant="filled"
                                            />
                                        )}
                                    />
                                </Grid>
                            </>
                        }
                        {
                            getValues("billingDeliveryMethod") === "mail" && editBillingDeliveryMethod &&
                            <Grid container spacing={2} justifyContent="center" alignItems="center">
                                <Grid item xs={12}>
                                    <h3 className={styles["h3"]}>收單地址</h3>
                                </Grid>
                                <Grid item xs={6}>
                                    <Controller
                                        name="addressInfo.area"
                                        control={control}
                                        rules={{ required: "required" }}
                                        render={({ field }) => (
                                            <TextField
                                                select
                                                inputProps={{ readOnly: !editBillingDeliveryMethod }}
                                                fullWidth
                                                {...field}
                                                onChange={(e) => {
                                                    field.onChange(e);
                                                    setAvailableAreaSubdistrictsOptions(availableAreaSubdistrictsData.subdistricts[e.target.value]);
                                                    setValue("addressInfo.secDistrict", availableAreaSubdistrictsData.subdistricts[e.target.value][0])
                                                }}
                                                label="地區"
                                                error={!!errors.addressInfo?.area}
                                                helperText={errors.addressInfo?.area ? errors.addressInfo?.area.message : ""}
                                                className={`${editBillingDeliveryMethod ? "" : "readonly"}`}
                                                variant="filled"
                                            >
                                                {
                                                    availableAreaSubdistrictsData.areas.map((option, index) => {
                                                        return (
                                                            <MenuItem key={index} value={option}>
                                                                {option}
                                                            </MenuItem>
                                                        )
                                                    })
                                                }
                                            </TextField>
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <Controller
                                        name="addressInfo.secDistrict"
                                        control={control}
                                        rules={{ required: "required" }}
                                        render={({ field }) => (
                                            <TextField
                                                select
                                                inputProps={{ readOnly: !editBillingDeliveryMethod }}
                                                fullWidth
                                                {...field}
                                                label="分區"
                                                error={!!errors.addressInfo?.secDistrict}
                                                helperText={errors.addressInfo?.secDistrict ? errors.addressInfo?.secDistrict.message : ""}
                                                variant="filled"
                                                className={`${editBillingDeliveryMethod ? "" : "readonly"}`}
                                            >
                                                {
                                                    availableAreaSubdistrictsOptions.map((option, index) => {
                                                        return (
                                                            <MenuItem key={index} value={option}>
                                                                {option}
                                                            </MenuItem>
                                                        )
                                                    })
                                                }
                                            </TextField>
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Controller
                                        name="addressInfo.street"
                                        control={control}
                                        render={({ field }) => {
                                            return(
                                                <TextField
                                                    {...field}
                                                    inputProps={{ readOnly: !editBillingDeliveryMethod }}
                                                    fullWidth
                                                    label="街道及號數"
                                                    error={!!errors.addressInfo?.street}
                                                    helperText={errors.addressInfo?.street ? errors.addressInfo?.street.message : ""}
                                                    variant="filled"
                                                />
                                            )
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Controller
                                        name="addressInfo.court"
                                        control={control}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                inputProps={{ readOnly: !editBillingDeliveryMethod }}
                                                fullWidth
                                                label="屋村/屋苑"
                                                error={!!errors.addressInfo?.court}
                                                helperText={errors.addressInfo?.court ? errors.addressInfo?.court.message : ""}
                                                variant="filled"
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Controller
                                        name="addressInfo.building"
                                        control={control}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                inputProps={{ readOnly: !editBillingDeliveryMethod }}
                                                fullWidth
                                                label="大廈"
                                                error={!!errors.addressInfo?.building}
                                                helperText={errors.addressInfo?.building ? errors.addressInfo?.building.message : ""}
                                                variant="filled"
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Controller
                                        name="addressInfo.block"
                                        control={control}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                inputProps={{ readOnly: !editBillingDeliveryMethod }}
                                                fullWidth
                                                label="座數"
                                                error={!!errors.addressInfo?.block}
                                                helperText={errors.addressInfo?.block ? errors.addressInfo.block?.message : ""}
                                                variant="filled"
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <Controller
                                        name="addressInfo.level"
                                        control={control}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                inputProps={{ readOnly: !editBillingDeliveryMethod }}
                                                fullWidth
                                                label="樓層"
                                                error={!!errors.addressInfo?.level}
                                                helperText={errors.addressInfo?.level ? errors.addressInfo.level?.message : ""}
                                                variant="filled"
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <Controller
                                        name="addressInfo.flat"
                                        control={control}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                inputProps={{ readOnly: !editBillingDeliveryMethod }}
                                                fullWidth
                                                label="室/單位"
                                                error={!!errors.addressInfo?.flat}
                                                helperText={errors.addressInfo?.flat ? errors.addressInfo.flat?.message : ""}
                                                variant="filled"
                                            />
                                        )}
                                    />
                                </Grid>
                            </Grid>
                        }
                        <Box width={"100%"} display={"flex"} justifyContent={"center"} gap={2}>
                            {
                                editBillingDeliveryMethod ?
                                    <>
                                        <Button
                                            type="button"
                                            variant="outlined"
                                            color="primary"
                                            size="medium"
                                            onClick={(e) => { e.preventDefault(); setEditBillingDeliveryMethod(false); reset(); }}
                                        >
                                            取消
                                        </Button>
                                        <Button
                                            type="button"
                                            variant="outlined"
                                            color="primary"
                                            size="medium"
                                            onClick={(e) => { e.preventDefault(); setComfirmDialogOpen(true); }}
                                        >
                                            {loading ? "儲存中" : "儲存"}
                                        </Button>
                                    </>
                                    :
                                    <>
                                        <Button
                                            type="button"
                                            variant="outlined"
                                            color="primary"
                                            size="medium"
                                            onClick={(e) => { e.preventDefault(); checkBillingDeliveryMethodEditable(); }}
                                        >
                                            編輯收單地址
                                        </Button>
                                    </>
                            }
                        </Box>
                        <Box textAlign={"left"} paddingTop={"12px"} fontSize={"13px"} color={"rgba(67, 71, 78, 1)"}>
                            請留意因您更改收單地址時帳單可能已進行印刷，更改只會在下一個月反映並郵寄至新地址。
                        </Box>
                        {
                            billingDeliveryData.canUpdateBillingDeliveryMethod && getValues("billingDeliveryMethod") === "mail" && !editBillingDeliveryMethod &&
                            <>
                                <hr style={{ color: "rgba(200, 200, 200, 1)" }} />
                                <Box width={"100%"} display={"flex"} justifyContent={"center"}>
                                    <Button
                                        type="button"
                                        variant="outlined"
                                        color="primary"
                                        size="medium"
                                        onClick={(e) => { e.preventDefault(); checkBillingDeliveryMethodEditable(true); }}
                                    >
                                        更換為電子郵件帳單
                                    </Button>
                                </Box>
                            </>
                        }
                        </Box>
                        <Dialog
                            open={comfirmDialogOpen}
                            onClose={handleClose}
                            disablePortal
                            maxWidth="md"
                            PaperProps={{style:{margin:0,borderRadius:"10px"}}}
                            sx={{ borderRadius: "40px", width: "100%" }}
                        >
                            <div className={styles["confirm-dialog"]}>
                                <div className={styles["dialog-close-div"]}>
                                    <CloseButton style={{ marginLeft: "auto" }} onClick={handleClose}></CloseButton>
                                </div>

                                <div className={styles["dialog-content"]}>
                                    <div className={styles["info-row"]}>
                                        <h1>確認以下收帳單方式</h1>
                                    </div>
                                    {
                                        getValues("billingDeliveryMethod") === "mail" &&
                                        <div className={styles["info-row"]}>
                                            <div className={styles["info-type"]}>收帳單地址</div>
                                            <div className={styles["info-value"]}>{billingAddressLine}</div>
                                        </div>
                                    }
                                    {
                                        getValues("billingDeliveryMethod") === "email" &&
                                        <div className={styles["info-row"]}>
                                            <div className={styles["info-type"]}>電郵地址</div>
                                            <div className={styles["info-value"]}>{getValues("emailAddress")}</div>
                                        </div>
                                    }
                                </div>
                                <div className={styles["dialog-actions"]}>
                                    <Button onClick={handleClose}>取消</Button>
                                    <Button
                                        type="submit"
                                        variant="outlined"
                                        color="primary"
                                        size="medium"
                                        disabled={loading}
                                    >
                                        儲存
                                    </Button>
                                </div>
                            </div>
                        </Dialog>
                        <Dialog
                            className={`${styles["file-input"]}`}
                            open={updateEmailDialogOpen}
                            onClose={handleUpdateEmailDialogClose}
                            disablePortal
                            maxWidth="md"
                            PaperProps={{style:{margin:0,borderRadius:"10px"}}}
                            sx={{ borderRadius: "40px", width: "100%" }}
                        >
                            <div className={styles["confirm-dialog"]}>
                                <div className={styles["dialog-close-div"]}>
                                    <CloseButton style={{ marginLeft: "auto" }} onClick={handleUpdateEmailDialogClose}></CloseButton>
                                </div>

                                <div className={styles["dialog-content"]}>
                                    <div className={styles["info-row"]}>
                                        請先登記電郵地址以編輯其他資訊。
                                    </div>
                                </div>
                                <div className={styles["dialog-actions"]}>
                                    <Button
                                        type="button"
                                        variant="outlined"
                                        color="primary"
                                        size="medium"
                                        onClick={handleUpdateEmailDialogClose}
                                    >
                                        取消
                                    </Button>
                                    <Button
                                        type="button"
                                        variant="outlined"
                                        color="primary"
                                        size="medium"
                                        onClick={() => { setEditProfile(true); handleUpdateEmailDialogClose(); }}
                                    >
                                        編輯
                                    </Button>
                                </div>
                            </div>
                        </Dialog>
                    </form>
                }
                {
                    (billingDeliveryData.canShowBillingDeliveryDetails === false) &&
                    <Box width={"100%"} maxWidth={"356px"} display={"flex"} flexDirection={"column"} margin={"0 auto"} gap={"12px"}>
                    <Box textAlign={"left"} paddingTop={"12px"} fontSize={"13px"} color={"rgba(67, 71, 78, 1)"}>
                        現時您名下的不同用戶的收帳單地址有所不同，如要更改收帳單方式，請您按頁面右下角“提供意見/客服查詢”聯絡客戶服務部。
                    </Box>
                    </Box>
                }
                </Card>
            </div>
        </>
    )
}

export default BillCollectionMethod